<template>
  <b-form @submit.prevent="buscar" class="ml-2">
    <b-input-group>
      <b-form-input v-model="term" type="search" size="sm" placeholder="Búsqueda" />
      <b-input-group-append>
        <b-button variant="primary" size="sm" type="submit">
          <v-icon variant="primary" name="search" width="16" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <input type="submit" style="display: none" />
  </b-form>
</template>
<script>
export default {
  data() {
    return { term: "" };
  },
  methods: {
    buscar(event) {
      const term = this.term.trim();
      const query = {};

      if (term != "") {
        query.busqueda = term;
      }

      this.$router.push({
        path: this.$route.path,
        query: query,
      });
    },
  },
};
</script>
